<div class="grid-container">
    <div class="header-helper" *ngIf="!staffView">
        These are the domains you manage. Click the domain name to review or make changes.
    </div>
    <div class="content content-with-elevation">
        <div class="grid-x filter-search-button-group">
            <div class="cell large-2 medium-12 small-12 filter-group" *ngIf="staffView">
                <fa-icon [icon]="'filter'" style="margin-right: 5px; "></fa-icon>
                <select [(ngModel)]="statusFilterOptionSelected" (change)="changeFilter()" class="select-box">
                    <option *ngFor="let myOption of statusFilterOptions" [value]="myOption">
                        {{ myOption }}
                    </option>
                </select>
            </div>
            <div class="cell large-3 medium-12 small-12 search-group">
                <input placeholder="Search" [(ngModel)]="searchText" class="filter" (keydown)="onKeydown($event)">
                <a (click)="search()" class="search-button">
                    <fa-icon [icon]="'search'" style="align-self: center"></fa-icon>
                </a>
            </div>
            <div class="cell large-3 medium-12 small-12 align-end" *ngIf="staffView">
                <button class="iana-button" (click)="createDomainOutput()">Create Domain</button>
            </div>
        </div>


        <div class="table-scroll" infiniteScroll
             [infiniteScrollDistance]="2"
             [infiniteScrollThrottle]="50"
             (scrolled)="onScroll()" style="width: 100%; margin-top: 16px">
            <table class="responsive-card-table unstriped" style="width: 100%">
                <thead style="background-color: white; border: 0">
                <tr style="border-top: 1px solid black;border-bottom: 1px solid black">
                    <th style="width:90%; text-align: left" *ngIf="!staffView">Domain</th>
                    <th style="width:25%; text-align: left" *ngIf="staffView">Domain</th>
                    <th style="width:20%; text-align: left" *ngIf="staffView">Special Inst</th>
                    <th style="width:20%; text-align: left" *ngIf="staffView">Type</th>
                    <th style="width:15%; text-align: left" *ngIf="staffView">Status</th>
                </tr>
                </thead>
                <tbody style="border:0">
                <tr class="spaceUnder" *ngFor="let domain of domains">
                    <td data-label="Domain" style="text-align: left">
                        <a class="a-link" (click)="editDomain(domain.id)">{{domain.name | domainNameConverter}}</a>
                    </td>
                    <td data-label="SpecialInst" style="text-align: center" *ngIf="staffView">
                        <fa-icon *ngIf="domain.metadata.specialInstructions" [icon]="'check'"></fa-icon>
                    </td>
                    <td data-label="Type" style="text-align: left"
                        *ngIf="staffView">{{domain.type| domainListHelper: 'type'}}</td>
                    <td data-label="Status" style="text-align: left" *ngIf="staffView"><span
                            class="label {{domain.status| domainListHelper: 'status'}}">{{domain.status}}</span></td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>